<div class="row row-cols-1 row-cols-sm-2 row-cols-xl-3 py-4 g-4">
  <div *ngFor="let device of final_device_list" class="col" role="listbox">
    <div
      as-button
      class="card h-100 elevate overflow-hidden"
      [attr.aria-label]="device.manufacturer + ' ' + device.model"
      (click)="selectAsset(device)"
    >
      <div class="card-body device-card px-0 pt-0">
        <div
          *ngIf="bpDeviceInCart(device)"
          class="position-absolute top-0 start-100 text-end currently-in-cart"
        >
          <span ngbTooltip="{{ 'selected_item' | translate }}" class="material-icons">
            check_circle
          </span>
        </div>
        <div class="bg-white d-flex flex-column justify-content-center align-items-center">
          <!-- Device Image -->
          <img
            class="device-card__img"
            src="{{ device.image_url }}"
            alt="{{ device.manufacturer }} {{ device.model }}"
            loading="lazy"
            (error)="getPlaceholder(device.product_category, $event)"
          />

          <!-- Color List -->
          <ul class="mt-3 p-0 d-flex justify-content-center" data-bs-theme="light">
            <li
              class="m-1 rounded-circle device-card__asset-colors--active"
              [ngClass]="{
                'multi-color': device.color === 'Multicolor',
              }"
              [ngStyle]="{
                'background-color': device.color !== 'Multicolor' ? (device.color | lowercase) : ''
              }"
            ></li>
          </ul>
        </div>

        <div class="pt-3 border-top device-card__content">
          <!-- Carrier Logo -->
          <span>
            <img
              class="img-fluid pb-1 carrier-logo"
              src="{{ device.carrier.image_url }}"
              [alt]="device.carrier.name"
            />

            <!-- Device Name -->
            <span class="d-flex flex-column device-card__content--bp_title line-clamp-2">
              <span>
                {{ device.manufacturer + ' ' + device.model }}
              </span>
              <h6 class="display-6 text-secondary mb-0">
                {{ device.original_color + ' - ' + device.size }}
              </h6>
            </span>
            <span class="d-inline-block my-3 device-card__content--title">
              <span class="text-break">{{ device.business_purpose }}</span>
            </span>
          </span>

          <!-- Device Amount -->
          <div class="text-limit lh-1">
            <small class="fw-normal">{{ 'as_low_as' | translate }}</small>
            <div class="d-flex align-items-end lh-base">
              <h5 class="pe-1 mb-0">{{ getBPDeviceMinimumPrice(device, 'onetime') }}</h5>
              <small class="text-secondary text-truncate">
                {{ 'one_time_payment' | translate }}
              </small>
            </div>
            <div *ngIf="hasMonthlyMinimumPrice(device)">
              <small class="text-secondary"> {{ 'plus' | translate }}&nbsp; </small>
              <h6 class="d-inline-block mb-0">
                {{ getBPDeviceMinimumPrice(device, 'monthly') }}/mo.
              </h6>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
